(function () {
  var style = document.createElement('style');
  style.textContent =
    '.embroidery-notice {' +
    'display: inline-block;' +
    'margin-top: 6px;' +
    'padding: 6px 10px;' +
    'background-color: rgba(255, 140, 0, 0.15);' +
    'border: 1px solid #ff8c00;' +
    'border-radius: 5px;' +
    'font-size: 12px;' +
    'line-height: 1.3;' +
    'color: #7a4a00;' +
    '}';
  document.head.appendChild(style);

  var EMBROIDERY_REGEX = /embroidered|embroidery/i;
  var NOTICE_TEXT = 'Custom embroidery has a 3.5 week turnaround.';

  var CONFIGS = [
    {
      // Cart page / cart drawer line items
      itemSelector: '.cart-item',
      nameSelector: '.cart-item__name',
      getAnchor: function (item) {
        var details = item.querySelector('.cart-item__details');
        if (!details) return null;
        return (
          details.querySelector(':scope > .cart-item__discounted-prices') ||
          details.querySelector(':scope > .product-option')
        );
      }
    },
    {
      // "Item added to your cart" flyout notification
      itemSelector: '#cart-notification-product',
      nameSelector: '.cart-notification-product__name',
      getAnchor: function (item) {
        return item.querySelector('.cart-notification-product__name');
      }
    }
  ];

  function addEmbroideryNotices() {
    CONFIGS.forEach(function (config) {
      document.querySelectorAll(config.itemSelector).forEach(function (item) {
        var nameEl = item.querySelector(config.nameSelector);
        if (!nameEl) return;

        var isEmbroidered = EMBROIDERY_REGEX.test(nameEl.textContent);
        var existingNotice = item.querySelector('.embroidery-notice');

        if (isEmbroidered && !existingNotice) {
          var anchor = config.getAnchor(item);
          if (anchor) {
            var notice = document.createElement('div');
            notice.className = 'embroidery-notice';
            notice.textContent = NOTICE_TEXT;
            anchor.insertAdjacentElement('afterend', notice);
          }
        } else if (!isEmbroidered && existingNotice) {
          existingNotice.remove();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addEmbroideryNotices);
  } else {
    addEmbroideryNotices();
  }

  new MutationObserver(addEmbroideryNotices).observe(document.body, {
    childList: true,
    subtree: true
  });
})();